/* Code generated with AutoHTML Plugin for Figma */
import { CSSProperties } from "react";
import { _colorText, _size, _sizeText } from "../../core/core";
import { Text } from "../texts/text";
import "./Stepper.css";

interface StepperProps {
    active?: boolean;
    size?: _size;
    size_text?: _sizeText;
    color?: string;
    count?: number | null;
    text?: string | null;
    top?: string | null;
    left?: string | null;
    [key: string]: any; // Для дополнительных пропсов
}

export const Stepper: React.FC<StepperProps> = ({
    active = false,
    size = _size.S,
    size_text = _sizeText.xs,
    color = _colorText.negative,
    count = null,
    text = null,
    top = null,
    left = null,
    ...props
}) => {
    const getPosition = () => {
        if (top && left) {
            return {
                position: 'relative',
                left: left,
                top: top,
            } as CSSProperties;
        }
        return undefined;
    };

    const getMainStyle = () => {
        if (top && left) {
            return { position: 'absolute' } as CSSProperties;
        }
        return undefined;
    };

    return (
        <div style={getMainStyle()} className="stepper-master" {...props}>
            <div
                style={getPosition()}
                className={`stepper-circle-${active} stepper-${color} stepper-size-${size}`}
            >
                <Text size={size_text}>{count}</Text>
            </div>
            {text && <Text size={size_text}>{text}</Text>}
        </div>
    );
};